import {Directive, inject, OnInit, signal} from '@angular/core';
import {SubsidyDossier} from '../services/subsidy-dossiers/subsidy-dossier.model';
import {ActivatedRoute, Router} from '@angular/router';
import {FormBuilder, FormGroup} from '@angular/forms';
import {LoadingService} from '../core/services/loading/loading.service';
import {SubsidyDossiersStore} from '../services/subsidy-dossiers/subsidy-dossiers.store';
import {ToastService} from '../core/services/toast/toast.service';
import {SubsidyDossiersService} from '../services/subsidy-dossiers/subsidy-dossiers.service';
import {FormComponent} from '../core/base/form.component';
import {switchMap} from 'rxjs/operators';

@Directive()
export abstract class ReportBaseComponent extends FormComponent implements OnInit {
	dossier = signal<SubsidyDossier | null>(null);

	MAX_LENGTH = 5_000;

	protected activeRoute = inject(ActivatedRoute);
	protected fb = inject(FormBuilder);
	protected subsidyDossiersService = inject(SubsidyDossiersService);
	protected loadingService = inject(LoadingService);
	protected router = inject(Router);
	protected subsidyDossiersStore = inject(SubsidyDossiersStore);
	protected toastService = inject(ToastService);

	ngOnInit() {
		window.scrollTo(0, 0);

		this.activeRoute.paramMap.pipe(
			switchMap(params => {
				const dossierId = params.get('dossierId')!;
				return this.subsidyDossiersStore.getDossier(+dossierId);
			})
		).subscribe(dossier => {
			this.dossier.set(dossier);
			this.form = this.createForm();
		});
	}

	submit(close: boolean) {
		if (close && this.isFormValid()) {
			const data = this.getData();

			this.loadingService.load();

			const dossier = this.dossier();

			if (dossier) {
				this.subsidyDossiersService.submitReport(dossier.type, dossier.id as number, data)
					.subscribe({
						next: () => {
							this.toastService.success('Je voortgangsrapport is doorgestuurd.');
							this.loadingService.done();
							this.router.navigate(['/']);
						},
						error: (err) => {
							this.toastService.serverError(err);
							this.loadingService.done();
						}
					});
			}
		}
	}

	protected getData(): any {
		return {
			...this.form.value,
		};
	}

	protected onInvalidForm(): void {
		this.toastService.formError();
	}

	protected resetInvalidForm(): void {
		this.toastService.clearToast();
	}

	protected abstract createForm(): FormGroup;
}
